import { render, staticRenderFns } from "./underConstruction.vue?vue&type=template&id=3e39793c&"
import script from "./underConstruction.vue?vue&type=script&lang=js&"
export * from "./underConstruction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports